import firebase from "../firebase";

export default function({ officeId, personId, roomId, meaningButtonId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "pagingUser",
        funcName: "pagePersonToRoom",
        data: { officeId, personId, roomId, meaningButtonId }
    });
}
